import { toast } from "react-toastify";

export const successToastContainerId = "success";
export const errorToastContainerId = "error";

export const toastFunction = (message, type, id = "success-toast") => {
  return toast(message, {
    position: "top-right",
    toastId: id,
    className: type,
    containerId: successToastContainerId,
  });
};

export const errorToastFunction = (error, toastId = "error-toast") => {
  let message = error?.message || "Something went wrong";
  if (error?.status_code) {
    message = `${message}. Status code ${error?.status_code}`;
  }

  return toast(message, {
    position: "top-right",
    toastId: toastId,
    className: "error",
    containerId: errorToastContainerId,
  });
};
